import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './deployment.reducer';

export const DeploymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deploymentEntity = useAppSelector(state => state.deployment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deploymentDetailsHeading">
          <Translate contentKey="integrawebApp.deployment.detail.title">Deployment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.id}</dd>
          <dt>
            <span id="tripName">
              <Translate contentKey="integrawebApp.deployment.tripName">Trip Name</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.tripName}</dd>
          <dt>
            <span id="recordStatus">
              <Translate contentKey="integrawebApp.deployment.recordStatus">Record Status</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.recordStatus}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="integrawebApp.deployment.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {deploymentEntity.createdDate ? <TextFormat value={deploymentEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="integrawebApp.deployment.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.createdBy}</dd>
          <dt>
            <span id="lastModifiedDate">
              <Translate contentKey="integrawebApp.deployment.lastModifiedDate">Last Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {deploymentEntity.lastModifiedDate ? (
              <TextFormat value={deploymentEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="integrawebApp.deployment.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.lastModifiedBy}</dd>
          <dt>
            <span id="deliveryDateFrom">
              <Translate contentKey="integrawebApp.deployment.deliveryDateFrom">Delivery Date From</Translate>
            </span>
          </dt>
          <dd>
            {deploymentEntity.deliveryDateFrom ? (
              <TextFormat value={deploymentEntity.deliveryDateFrom} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="deliveryDateTil">
              <Translate contentKey="integrawebApp.deployment.deliveryDateTil">Delivery Date Til</Translate>
            </span>
          </dt>
          <dd>
            {deploymentEntity.deliveryDateTil ? (
              <TextFormat value={deploymentEntity.deliveryDateTil} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="nrbsFrom">
              <Translate contentKey="integrawebApp.deployment.nrbsFrom">Nrbs From</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.nrbsFrom}</dd>
          <dt>
            <span id="nrbsTil">
              <Translate contentKey="integrawebApp.deployment.nrbsTil">Nrbs Til</Translate>
            </span>
          </dt>
          <dd>{deploymentEntity.nrbsTil}</dd>
        </dl>
        <Button tag={Link} to="/deployment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/deployment/${deploymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeploymentDetail;
